import React, { useMemo } from "react";
import { Box, Button } from "@mui/material";

function a11yProps(tabId) {
  return {
    id: `shared-tab-${tabId}`,
    "aria-controls": `shared-tabpanel-${tabId}`,
  };
}

const SharedTabs = ({ tabs, selectedTabId, onChange }) => {
  // if showTab is false, filter out tab
  const activeTabs = useMemo(() => tabs?.filter((tab) => tab.showTab), [tabs]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        gap: "8px",
        borderBottom: "1px solid #E2772E",
        paddingBottom: "8px",
      }}
    >
      {activeTabs.map((tab) => (
        <Button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          sx={{
            fontSize: "14px",
            color: selectedTabId === tab.id ? "#FFF" : "#000",
            backgroundColor:
              selectedTabId === tab.id ? "#E2772E" : "transparent",
            padding: "4px 8px",
            border: "none",
            borderRadius: "4px",
            "&:hover": {
              color: selectedTabId === tab.id ? "#FFF" : "#000",
              backgroundColor:
                selectedTabId === tab.id ? "#E2772E" : "transparent",
              border: "none",
            },
            "&.Mui-disabled": {
              color: selectedTabId === tab.id ? "#FFF" : "#000",
              backgroundColor:
                selectedTabId === tab.id ? "#E2772E" : "transparent",
              border: "none",
            },
          }}
          {...a11yProps(tab.id)}
        >
          {tab.label}
        </Button>
      ))}
    </Box>
  );
};

export default SharedTabs;
